import { useRef } from 'react'
import { useSafeState } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Spin } from 'antd'
import { ProForm, ProFormText, ProFormSelect, ProFormDigit, ProFormDependency, ProFormTextArea } from '@ant-design/pro-components'

export default function ({ store, params }) {
  const [ data, dispatch ] = useSafeState<any>()
  const [ fileType ] = React.useMemo(() => [ store.config.getConstantPairs('FileType') ], [])

  return <div className='p-4 m-4 bg-white'>
    <table className='w-full border-collapse border border-slate-300 mb-8'>
      <thead>
        <tr>
          <th colSpan={4} className='border border-slate-300 text-left p-3 bg-gray-200 text-gray-600 font-bold'>订单信息</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>订单编号</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-white'>{data?.orders?.number}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>客户姓名</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{data?.orders?.customerName}</td>
        </tr>

        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>联系电话</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{data?.orders?.customerPhone}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>下单时间</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{data?.orders?.createTime}</td>
        </tr>

        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>尾款金额</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{data?.orders?.totalAmount - data?.orders?.paidAmount}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>已收金额</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{data?.orders?.paidAmount}</td>
        </tr>

        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>总金额</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{data?.orders?.totalAmount}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'></td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'></td>
        </tr>
      </tbody>
    </table>

    <ProForm
      layout='vertical'
      submitter={false}
      key={params.flow}
      request={async () => {
        const [ flow , result ] = await Promise.all([
          store.externals.api.get(`/paymentRecords/flow/${params.flow}`),
          store.externals.api.get(`/paymentRecords/flow/detail/${params.id}`)
        ])

        dispatch(result)

        return Object.assign(flow, {
          isDeposit: result.orders.isDeposit,
          noDepositReason: result.orders.noDepositReason,
          excel: result.fileManageList.filter(file => file.type == fileType.quotationFile),
          receipt: result.fileManageList.filter(file => file.type == fileType.receiptVoucher),
        })
      }}
    >
      <ProFormDependency name={[ 'isDeposit' ]}>
        {({ isDeposit }) => {
          if (isDeposit == 'no') {
            return null
          }

          return <UploadImage
            readonly
            max={10000}
            name='receipt'
            label='报价时收款凭证'
            help='建议尺寸800*800px'
          />
        }}
      </ProFormDependency>

      <UploadFile
        readonly
        max={10}
        name='excel'
        label='报价xls文件存档'
        convertValue={data => R.is(Array, data) ? data.map((e: any) => ({ ...e, filename: e.fileName || e.filename })) : data}
      />

      <ProFormDependency name={[ 'isDeposit' ]}>
        {({ isDeposit }) => {
          if (isDeposit == 'yes') {
            return null
          }

          return <ProFormTextArea
            readonly
            name='noDepositReason'
            label='报价时没有收款下单原因'
            fieldProps={{ rows: 6 }}
          />
        }}
      </ProFormDependency>

      <ProFormSelect
        readonly
        name='item'
        label='货款类型'
        width='xl'
        valueEnum={{ '订金': '订金', '尾款': '尾款' }}
        rules={[ { required: true, message: '请填写货款类型' } ]}
      />

      <ProFormText
        readonly
        name='payStatus'
        label='收款方式'
        width='xl'
        rules={[ { required: true, message: '请填写收款方式' } ]}
      />

      <ProFormDigit
        readonly
        name='amount'
        label='收款金额'
        width='xl'
        min={0}
        fieldProps={{ precision: 2 }}
        rules={[ { required: true, message: '请填写收款金额' } ]}
      />

      <UploadImage
        readonly
        max={10000}
        name='fileManageList'
        label='上传收款凭证'
        help='建议尺寸800*800px'
        rules={[ { required: true, message: '请上传收款凭证' } ]}
        convertValue={data => R.is(Array, data) ? data.map((e: any) => ({ ...e, filename: e.fileName || e.filename })) : data}
      />
    </ProForm>
  </div>
}
